module.exports = __webpack_public_path__ + "img/jiazhiguan.c5316acd.png";